import { useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import styles from "../../styles/home.module.css";

const HomeCarousel = ({ children }) => {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(280, el.clientWidth * 0.72), behavior: "smooth" });
  };

  return (
    <div className={styles.carousel}>
      <button
        type="button"
        aria-label="التالي"
        onClick={() => scroll(-1)}
        className={`${styles.navBtn} ${styles.navBtnNext}`}
      >
        <FiChevronLeft />
      </button>

      <button
        type="button"
        aria-label="السابق"
        onClick={() => scroll(1)}
        className={`${styles.navBtn} ${styles.navBtnPrev}`}
      >
        <FiChevronRight />
      </button>

      <div className={styles.track} ref={trackRef}>
        {children}
      </div>
    </div>
  );
};

export default HomeCarousel;
